<template>

</template>

<script>
export default {
  name: 'load-more',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    scrollElement: {
      type: String,
      default: '.main-viewport'
    },
    scrollOffsetBottom: {
      type: Number,
      default: 10
    }
  },
  created () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', () => {})
  },
  methods: {
    onScroll () {
      //可滚动容器的高度
      let innerHeight = document.querySelector(this.scrollElement).clientHeight
      //屏幕尺寸高度
      let outerHeight = document.documentElement.clientHeight
      //可滚动容器超出当前窗口显示范围的高度
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      //scrollTop在页面为滚动时为0，开始滚动后，慢慢增加，滚动到页面底部时，出现innerHeight < (outerHeight + scrollTop)的情况，严格来讲，是接近底部。
      if (!this.value && innerHeight < (outerHeight + scrollTop + this.scrollOffsetBottom)) {
        //加载更多操作
        this.$emit('more')
      }
    }
  }
}
</script>

<style scoped>

</style>
